<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="7" viewBox="0 0 16 7">
		<g transform="translate(-4 -141.5)">
			<g transform="translate(4 141.5)" fill="none" stroke="#ffffff" stroke-width="1">
				<rect width="16" height="7" rx="3.5" stroke="none"></rect>
				<rect x="0.5" y="0.5" width="15" height="6" rx="3" fill="none"></rect>
			</g>
			<path
				d="M44.047,339.043H40.94"
				transform="translate(-31.723 -193.543)"
				fill="#dbe5ff"
				stroke="#6b7786"
				stroke-linecap="round"
				stroke-miterlimit="10"
				stroke-width="1"
			></path>
			<path
				d="M42.129,339.043H40.94"
				transform="translate(-26.723 -193.543)"
				fill="#dbe5ff"
				stroke="#ffffff"
				stroke-linecap="round"
				stroke-miterlimit="10"
				stroke-width="1"
			></path>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'LinkSVG',
};
</script>
